<template lang="pug">
	span(v-on-click-outside="close")
		span.icon-info(:id="tooltipID" @click="clickAnimation()" :class="{clicked: clicked}")
			span(:class="{hidden: clicked}")
				| i
			span.open(@click="close($event)")
				| x
		b-tooltip(:target="tooltipID"  :show.sync="clicked" triggers="none" ref="tooltip")
			span(v-html="tooltipTitle()")
			div(style='text-align:center;margin-top:5px')
				slot
				span.tooltip-close(@click="close($event)")
					| Close
</template>

<style lang="stylus" scoped>
@import '../assets/css/variables.styl'


.icon-info
	position: relative
	display inline-block
	border-radius 50%
	background #cbd1e1
	color #fff
	width 12px
	height 12px
	text-align center
	cursor pointer
	font-size 8px
	vertical-align middle
	transition-all()
	span
		display: inline-block
		margin-top: 2px
	.hidden
		display: block
		position: absolute
		top: -1px
		right: 5px
		-webkit-user-select none
		-moz-user-select none
		-ms-user-select none
		user-select none
	.open
		display none
		position: absolute
		top: -2px
		margin-top: 0
		right: 4px
	&:hover
		background sfc-gray-dark
	&.clicked
		background-color: sfc-brick
		.hidden
			display none
		.open
			display inline-block

.tooltip-close
	font-size: body-font-size-xs
	text-decoration:underline
	cursor:pointer

</style>

<script>
import Vue from 'vue'

import {directive as onClickOutside} from 'vue-on-click-outside'
import { BTooltip } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'


Vue.component('b-tooltip', BTooltip)


Vue.directive('on-click-outside', onClickOutside)

export default {

	props: ['title', 'startOpened'],

	data(){
		return {
			clicked: false,
			tooltipID: Math.floor(Math.random() * 1123).toString()
		}
	},

	mounted(){
		if(this.startOpened) {
			this.clickAnimation()
		}
	},
	computed: {

	},
	methods: {
		tooltipTitle(){
			return this.title
		},
		close(event){
			if(event){
				event.stopPropagation()
			}

			this.$root.$emit('bv::hide::tooltip', this.tooltipID);
			this.clicked = false
		},
		clickAnimation(){
			this.$root.$emit('bv::hide::tooltip');
			this.$root.$emit('bv::show::tooltip', this.tooltipID);
			this.clicked = true
		}
	}
}
</script>
